/** Times the exit of #splash: never cuts public/splash.svg's animation short, and holds while the app still loads. */

const ANIMATION_MS = 2600;
const REDUCED_MOTION_MS = 600;
const HOLD_MS = 200;
const LOAD_TIMEOUT_MS = 3000;

let loaded = null;

function animationMs() {
  return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
    ? REDUCED_MOTION_MS
    : ANIMATION_MS;
}

/** Resolves with the logo's load time (its animation start), stamped by index.html's onload/onerror. */
function whenLoaded(img) {
  loaded ??= new Promise((resolve) => {
    const stamp = () => resolve(Number(img.dataset.loadedAt));
    if (img.dataset.loadedAt) return stamp();
    img.addEventListener("load", stamp, { once: true });
    img.addEventListener("error", stamp, { once: true });
    setTimeout(() => resolve(performance.now() - animationMs()), LOAD_TIMEOUT_MS);
  });
  return loaded;
}

async function msUntilAnimationEnd(img) {
  return (await whenLoaded(img)) + animationMs() - performance.now();
}

/** Starts the animation once the native splash is down; a no-op on web, where index.html drops #splash. */
export function playSplash() {
  const img = document.getElementById("splash-logo");
  if (!img) return;
  if (!img.getAttribute("src")) img.src = img.dataset.src;

  msUntilAnimationEnd(img).then((wait) => {
    setTimeout(() => document.getElementById("splash")?.classList.add("splash-waiting"), Math.max(0, wait));
  });
}

export function setSplashProgress(percent) {
  const bar = document.getElementById("splash-progress-bar");
  if (bar) bar.style.width = `${percent}%`;
}

/** Fades the splash out once its animation has played; `immediate` skips the wait (fatal errors). */
export async function dismissSplash({ immediate = false } = {}) {
  const splash = document.getElementById("splash");
  if (!splash || splash.classList.contains("splash-hidden")) return;

  const img = document.getElementById("splash-logo");
  if (!immediate && img) {
    const wait = (await msUntilAnimationEnd(img)) + HOLD_MS;
    if (wait > 0) await new Promise((resolve) => setTimeout(resolve, wait));
  }

  // The progress bar's own transitions bubble up here too.
  splash.addEventListener("transitionend", (e) => e.target === splash && splash.remove());
  splash.classList.add("splash-hidden");
}
